import React, { useEffect, useState } from 'react';
// import Game from '../../../class/Game/Game';
import Games from '../../../class/Game_copy/Game';
import { useTranslation } from 'react-i18next';

import LOAD_GAMES_BY_PROVIDER_ID from './load_games_by_provider_id';
const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;
const ALL_PROVIDERS = ({ AuthServices, UserService,onClose, casinoSections, isLogged,setIsLoginModalOpen  }) => {
    const [providers, setProviders] = useState([]); 
    const [loading, setLoading] = useState(true);  
    const {t} = useTranslation();

    const [showGamesModal, setShowGamesModal] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null); 

    useEffect(() => {
        const fetchProviders = async () => {
            try {
                setLoading(true); 
                const user_id = AuthServices.getCustom('user_id') || ''; 
                const response = await Games.getAllProviders(user_id); 

                // console.log(response);
               
                const categories = ["Not found", "casino", "casino_live", "poker", "bingo", "virtual", "sport", "crash_games"];
                
                const filteredProviders = response.params
                    .map(provider => {
                    const game_category = categories[provider.category_id];
                    return {
                        ...provider,
                        category_name: game_category
                    };
                    })
                    .filter(provider => casinoSections[provider.category_name] == false);
                    setProviders(filteredProviders || []); 


            } catch (error) {
                console.error(`${t('Error_fetching_providers')}:`, error); 
            } finally {
                setLoading(false); 
            }
        };

        fetchProviders(); 
    }, []);

    const openGamesModal = (provider) => {
      setSelectedProvider(provider); 


      
      

      setShowGamesModal(true); 
  };

  const closeGamesModal = () => {
      setShowGamesModal(false); 
      setSelectedProvider(null); 
  };

    const getProviderIcon = (providerslug) => {
      return `${cmsUrl}static-assets/providers/${providerslug}.png`;
    };

    return (
      <>

   {!showGamesModal ? (

      <div
      className={`modal fade provider-box-modal ${providers.length > 0 ? 'show' : ''}`}
      id="ProviderModal"
      tabIndex="-1"
      style={{ display: 'block' }} 
     
      >
            <div className="modal-dialog modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="Home_header">
                            <a href="#" className="HomeSection_header" data-bs-dismiss="modal" aria-label="Close">
                                <div className="HomeSection_icon">
                                    <div className="arrow left"></div>
                                </div>
                                <div className="HomeSection_label" onClick={onClose} 
                                  style={{ cursor: 'pointer' }}>{t('back')}</div>
                                <div className="HomeSection_right"></div>
                            </a>
                        </div>

                        {loading ? (
                           <p>{t('Loading_providers')}...</p> 
                        ) : (
                            <div className="modalProvider-iconBox">
                                {providers.map((provider, index) => (
                                    <a href="#" key={index} onClick={() => openGamesModal(provider)}>
                                        <img src={getProviderIcon(provider.slug) || 'img/icon-provider/default-icon.png'} alt={provider.name} />
                                        <p>
                                            {provider.name || 'Unnamed Provider'}<br />
                                            <small>{provider.active_games || '0'} {t('Games')}</small>
                                        </p>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>

      ) : (
         <LOAD_GAMES_BY_PROVIDER_ID
            Game={Games}
            user_id={AuthServices.getCustom('user_id') || ''}
            provider_id={selectedProvider?.id} 
            category_id={selectedProvider?.category_id} 
            provider_name={selectedProvider?.name}
            provider_slug={selectedProvider?.slug}
            onClose={closeGamesModal} 
            isLogged={isLogged}
            setIsLoginModalOpen={setIsLoginModalOpen}
         />
      )}
        </>
    );
};

export default ALL_PROVIDERS;
